import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      enterTxt: "Enter",
      exForm: "",
      index: 2,
      sentences: ["######", "X##XXXX", "GXX##X", "WEB##X"],
    };
  }
  static defaultProps = {
    updateableText: "Submit",
    classButton: "",
  };

  async handleClick() {
    var data;
    var type;
    try {
      const response = await fetch(
        "https://api.csfrederick.com/data/" + this.state.inputValue,
        { mode: "cors" }
      );
      data = await response.json();
      type = 1;
    } catch (err) {
      try {
        const response = await fetch(
          "https://api.csfrederick.com/uuid/" + this.state.inputValue,
          { mode: "cors" }
        );
        data = await response.json();
        type = 2;
      } catch (err) {
        data = "ID doesn't exist!";
      }
    }
    if (data === "ID doesn't exist!") {
      this.setState({ enterTxt: "Try again", exForm: "Fail" });
    } else {
      if (type === 1) {
        window.location.href = "/photo?id=" + this.state.inputValue;
      } else {
        window.location.href = "/uuid?uuid=" + this.state.inputValue;
      }
    }
  }

  render() {
    const { inputValue, enterTxt, exForm } = this.state;

    return (
      <div className="App" style={{ margin: "-8px" }}>

        <style>{`
  @property --a {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }
`}</style>

        <HelmetProvider>
          <Helmet>
            <title>Project and Media Lookup</title>
            <meta
              name="Project and Media Lookup"
              content="Find Polaroids you're in and projects you have special access to."
              description="Find Polaroids you're in and projects you have special access to."
              author="Jack Frederick"
            />
          </Helmet>
        </HelmetProvider>

        <Warning />
        <Navbar />

        <header className="Home">
          <br />
          <div className="screenBox Minsize">
            <p className="Homethick lookup-enter-title">Project Lookup</p>
            <p className="Homesmall lookup-enter-subtitle" style={{ animationDelay: "0.21s" }}>
              Find Polaroids you're in and projects you have special access to.
            </p>
            <p className="Homemid lookup-enter-subtitle"  style={{ animationDelay: "0.26s" }}>Enter your 6 character lookup ID:</p>
            <div className="photoSpacer" />
            <div className="lookup-enter-form" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "14px" }}>

              <div className="lookup-input-wrap">
                <input
                  name="lookupID"
                  id="lookupID"
                  className="lookup-input"
                  type="text"
                  maxLength="6"
                  placeholder="XXXXXX"
                  value={inputValue}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  data-form-type="other"
                  onChange={(evt) => this.updateInputValue(evt)}
                  onKeyDown={(ev) => {
                    if (ev.key === "Enter") this.handleClick();
                  }}
                />
              </div>

              <div className={`lookup-pill ${inputValue.length === 6 ? "ready" : "waiting"}`}>
                <span className="lookup-pill-dot" />
                {inputValue.length === 6
                  ? "Ready to look up"
                  : `${inputValue.length} / 6 characters`}
              </div>
                <br/>
              <button
                type="submit"
                className={`lookup-btn ${exForm}`}
                onClick={async () => { await this.handleClick(); }}
              >
                {enterTxt}
              </button>
            </div>

            <div className="photoSpacer" />
            <div className="photoSpacer" />
          </div>
        </header>

        <Footer />
      </div>
    );
  }

  updateInputValue(evt) {
    const val = evt.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    this.setState({ inputValue: val });
  }
}

export default App;